<div class="container-fluid content-wrapper pt-5" style="margin-top:3rem;">
    <div class="">
      <div class="text-center">
        <h5 class="card-title">Update Requests Status
        </h5>
      </div>
      <div class="card-body">
        <div class="row mb-4">
            <div class="col-md-3"></div>
            <div class="col-md-2">
              <label for="selectrequest" class="form-label" >Request For:</label>
              </div>
              <div class="col-md-4">
                <select  name="application_type" id="application_type" class="form-select" (change)="getrequesttype($event.target)" >
                  <option selected hidden [disabled]="true">Select Request Type</option>
                  <option *ngFor="let fees of allfeesdata" [value]="fees.application_type">{{fees.application_type_name}}</option>
                </select>
            </div>  
        </div>
        <!-- <div class="row  form-group mb-3">
          <div class="col-md-3"></div>
          <div class="col-md-1">
            <label for="startdate" class="form-label">Start Date: </label>
          </div>
          <div class="col-md-2">
            <input  type="date" class="form-control" formControlName="startdate" >
            <div class="invalid-feedback">
              <div >Please Enter Start Date</div>
            </div>
          </div>
         <div class="col-md-1 form-group">
            <label for="enddate" class="form-label rptlbl">End Date:</label>
            </div>
            <div class="col-md-2">
            <input class="form-control" id="enddate" required type="date" formControlName="enddate">
            <div class="invalid-feedback">
              <div>Please Enter End Date</div>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div> -->
        <div *ngIf="showtable" style="height: 100%; box-sizing: border-box;">
          <ag-grid-angular
           #agGrid
            style="width: 100%; height:450px;"
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [pagination]="true"
            [paginationPageSize]="10"
            [suppressRowClickSelection]="true"
            rowSelection="multiple"
            [rowData]="rowData[0]"
            [animateRows]="true"
         
          ></ag-grid-angular>
        </div>
        <div *ngIf="!showtable">
          <div class="alert alert-secondary text-center com-md-3">
            <p class="h5"><i class="bi bi-list-check"></i><br>No Request to Show</p>
        </div>
        </div>
    </div>
  </div>
  <div *ngIf="showtable" style="text-align: end;" class="mt-1">
    <button class="btn btn-primary" (click) ="onBtExport()">Download to Excel
    </button>
  </div>
  </div>
  <div class="modal fade pt-5" id="exampleModal"data-bs-backdrop="static"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header alert alert-secondary">
          <h5 class="modal-title" id="exampleModalLabel">Application Id: {{application_id}}/{{exam_month_year}}/{{standard}}/{{seat_no}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="refreshPage()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form method="post" role="form" #form="ngForm" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)">
          <div class="container">
            <div class="row">
              <div class="col-md-4 mb-3 statuscont" style="padding-left: 3rem;">
                <div class="row">
                  <h5  class="statusheadings  alert alert-info">Request Status</h5>
                </div>
                <div class="row">
                    <div class="form-check ">
                      <input class="form-check-input"    (change)="checkstatus($event.target)"  formControlName="rdoRequestStatus" [attr.disabled]="canchangerequeststatus?true:null" type="radio" name="rdoRequestStatus" id="Submitted" value="Submitted" >
                      <label class="form-check-label" for="Submitted">
                        Submitted
                      </label>
                    </div>
                    <div class="form-check ">
                      <input class="form-check-input" (change)="checkstatus($event.target)"  formControlName="rdoRequestStatus" [attr.disabled]="canchangerequeststatus?true:null" type="radio" name="rdoRequestStatus" id="Approved" value="Approved" >
                      <label class="form-check-label" for="Approved">
                        Approved
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" (change)="checkstatus($event.target)" formControlName="rdoRequestStatus" [attr.disabled]="canchangerequeststatus?true:null" type="radio" name="rdoRequestStatus" id="Pending" value="Pending" >
                      <label class="form-check-label" for="Pending">
                        Pending
                      </label>
                    </div> 
                    <div class="form-check">
                      <input class="form-check-input" (change)="checkstatus($event.target)" formControlName="rdoRequestStatus" [attr.disabled]="canchangerequeststatus?true:null" type="radio" name="rdoRequestStatus" id="rejected" value="Rejected" >
                      <label class="form-check-label" for="rejected">
                        Rejected
                      </label>
                    </div> 
                </div>
                <div class="row mt-3">
                  <label for="inputPassword3" class="form-label"><b>Request Status Remarks:</b></label>
                  <textarea class="form-control" formControlName="remarkRequestStatus" [attr.disabled]="canchangerequeststatus?true:null">         </textarea>
                </div>
              </div>
              <div class="col-md-4 mb-3 statuscont" style="padding-left: 3rem;">
                <div class="row">
                  <h5  class="statusheadings    alert alert-info">Application Status</h5>
                </div>  
                <div class="row justify-content-center">
                  <div class="form-check ">
                    <input class="form-check-input"     formControlName="rdoApplicationStatus" [attr.disabled]="canchangeapplicationstatus?true:null" type="radio" name="rdoApplicationStatus" id="Printed" value="Printed" >
                    <label class="form-check-label" for="Printed">
                      Printed
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input"     formControlName="rdoApplicationStatus" [attr.disabled]="canchangeapplicationstatus?true:null" type="radio" name="rdoApplicationStatus" id="Dispatched" value="Dispatched" >
                    <label class="form-check-label" for="Dispatched">
                      Dispatched By Post/ Courior
                    </label>
                  </div> 
                  <div class="form-check">
                    <input class="form-check-input"     formControlName="rdoApplicationStatus" [attr.disabled]="canchangeapplicationstatus?true:null" type="radio" name="rdoApplicationStatus" id="Collected" value="Collected" >
                    <label class="form-check-label" for="Collected">
                      Collected in person
                    </label>
                  </div> 
                  <div class="form-check">
                    <!-- <input class="form-check-input"     formControlName="rdoApplicationStatus" type="radio" name="rdoApplicationStatus" id="Collected" value="Collected" > -->
                    <label class="form-check-label" for="">
                      <!-- Collected in person -->
                    </label>
                  </div> 
              </div>
              <div class="row mt-3">
                <label for="inputPassword3" class="form-label"><b>Application Status Remarks:</b></label>
                <textarea class="form-control" formControlName="remarkApplicationStatus" [attr.disabled]="canchangeapplicationstatus?true:null">         </textarea>
              </div>
              </div>
              <div class="col-md-4 mb-3 statuscont" style="padding-left: 3rem;">
                <div class="row">
                  <h5 class="statusheadings alert alert-info">Payment Status</h5>
                </div>  
                <div class="row justify-content-center">
                  <div class="form-check ">
                    <input class="form-check-input"   (change)="checkstatus($event.target)"    formControlName="rdoPaymentStatus" type="radio" name="rdoPaymentStatus" id="Paid" value="Paid" >
                    <label class="form-check-label" for="Paid">
                      Paid
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input"  (change)="checkstatus($event.target)"  formControlName="rdoPaymentStatus" type="radio" name="rdoPaymentStatus" id="Unpaid" value="Unpaid" >
                    <label class="form-check-label" for="Unpaid">
                      Unpaid
                    </label>
                  </div> 
                  <div class="form-check">
                    <!-- <input class="form-check-input"  type="radio" name="rdoPaymentStatus" id="Collected" value="Collected" > -->
                    <label class="form-check-label" for="">
                      <!-- Collected in person -->
                    </label>
                  </div> 
                  <div class="form-group ">
                    <!-- <input class="form-check-input" type="radio" name="rdoPaymentStatus" id="Collected" value="Collected" > -->
                     <label class="form-check-label" for="">
                      <!-- Collected in person -->
                    </label> 
                    <button type="button" (click)="openmodal('transactionModel')"  class="btn alert-primary">
                      No Of Transactions: <span class="badge rounded-pill bg-secondary">{{totalpaymentcount}}</span>
                    </button>
                  </div> 
              </div>
              <div class="row mt-3">
                <label for="inputPassword3" class="form-label"><b>Payment Status Remarks:</b></label>
                <textarea class="form-control" formControlName="remarkPaymentStatus">         </textarea>
              </div>
              </div>
            </div>
            <div class="row">
              <div class="text-end pt-3">
                <input *ngIf="generateCertificatecheck" [attr.disabled]="showgeneratebutton?true:null" value="Generate Certificate" type="button" class="btn-info btn  btn-block btnlogin  mx-3" (click)="generateCertificate()">
                <input *ngIf="generateCertificatecheck" [attr.disabled]="showprintbutton?true:null" value="Print" type="button" class="btn-info btn  btn-block btnlogin  mx-3" (click)="generateapplicationPdf()">
                
                <button type="submit" [attr.disabled]="chkdisabled?true:null" class="btn btn-warning mx-3" >Update</button>
                <!-- <button type="reset" [attr.disabled]="chkdisabled?true:null" class="btn btn-info mx-3">Clear</button> -->
                <button type="button" class="btn btn-secondary mx-3" data-bs-dismiss="modal" (click)="refreshPage()">Cancel</button>
              </div>
            </div>
          </div>
          </form>
        </div>
  </div>
  </div>
  </div>
<!-- The Modal to display transactions-->
<div id="transactionModel" class="modal1">
  <span class="close1" (click)="closemodal('transactionModel')">&times;</span>
  <img class="modal-content1" id="img01">
  <div id="caption">
      <div><h3>Transaction History Of : {{application_id}}</h3></div>
  </div>
  <div class="row">
        <div class="col-sm-12">
            <div class="tablecont mx-auto">
              <table class="table table-secondary table-hover" >
                <thead>
                    <tr>
                          <th>Payment Id</th>
                          <th>Trasaction Id</th>
                          <th>Transaction Date</th>
                          <th>Total Amount</th>
                          <th>Payment Status</th>
                          <th>Payment Remark</th>
                      </tr>
                </thead>
                <tbody *ngIf="paymentData">
                      <tr *ngFor="let p of paymentData">
                          <td>{{p.paymentid}}</td>
                          <td>{{p.transaction_id}}</td>
                          <td>{{p.application_fees_paid_date}}</td>
                          <td>{{p.total_payment}}</td>
                          <td>{{p.payment_status}}</td>
                          <td>{{p.payment_status_remark}}</td>
                      </tr>
                </tbody>
                <tbody *ngIf="paymentData==''">
                      <tr class="text-center text-danger">
                        <td colspan="6"><h5><em>No Transaction Found</em></h5></td>
                        </tr>
                </tbody>
              </table>
            </div>
        </div>
      </div>
</div>
<div *ngIf="proccessing" class="loadingcont">
  <div class="spinner"></div>
</div>